<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <form [formGroup]="stationForm">
                <div class="row">

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="a_1">Station*</label>
                            <input id="a_1" class="form-control"  [readonly]="isEditMode" formControlName="stationId" placeholder="Station" type="text" [ngClass]="{'is-invalid': submitted && StationControls.stationId.errors}">
                            <div *ngFor="let validation of validation_messages.stationId">
                                <div class="error-message" *ngIf="StationControls.stationId.hasError(validation.type) && ((StationControls.stationId.dirty  || StationControls.stationId.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>   
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="a_1">Station Code*</label>
                            <input id="a_1" class="form-control"  [readonly]="isEditMode" formControlName="stationCode" placeholder="Station Code" type="text" [ngClass]="{'is-invalid': submitted && StationControls.stationId.errors}">
                            <div *ngFor="let validation of validation_messages.stationCode">
                                <div class="error-message" *ngIf="StationControls.stationCode.hasError(validation.type) && ((StationControls.stationCode.dirty  || StationControls.stationCode.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>   
                    
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="rn">Airport *</label>
                            <input id="rn" class="form-control"  [readonly]="isEditMode" formControlName="airportName" placeholder="Airport (Sation)" type="text" [ngClass]="{'is-invalid': submitted && StationControls.airportName.errors}">
                            <div *ngFor="let validation of validation_messages.airportName">
                                <div class="error-message" *ngIf="StationControls.airportName.hasError(validation.type) && ((StationControls.airportName.dirty  || StationControls.airportName.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div> 

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="rn">Time Zone *</label>
                            <ng-select id="station" [multiple]="false"  formControlName="timeZone" [ngClass]="{'is-invalid': submitted && StationControls.timeZone.errors}" placeholder="Timezone">
                                <ng-option *ngFor="let timezone of timezones" [value]="timezone.name">
                                   {{timezone.name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.timeZone">
                                <div class="error-message" *ngIf="StationControls.timeZone.hasError(validation.type) && ((StationControls.timeZone.dirty  || StationControls.timeZone.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>                

                <div class="row">  

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="a_1">Address *</label>
                            <input id="a_1" class="form-control" formControlName="address" placeholder="Address-1" type="text" [ngClass]="{'is-invalid': submitted && StationControls.address.errors}">
                            <div *ngFor="let validation of validation_messages.address">
                                <div class="error-message" *ngIf="StationControls.address.hasError(validation.type) && ((StationControls.address.dirty  || StationControls.address.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>                  

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="city">City *</label>
                            <input id="city" class="form-control"  [readonly]="isEditMode" formControlName="city" placeholder="City" type="text" [ngClass]="{'is-invalid': submitted && StationControls.city.errors}">
                            <div *ngFor="let validation of validation_messages.city">
                                <div class="error-message" *ngIf="StationControls.city.hasError(validation.type) && ((StationControls.city.dirty  || StationControls.city.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>        

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="state">State *</label>
                            <input id="state" class="form-control"  [readonly]="isEditMode" formControlName="state" placeholder="State" type="text" [ngClass]="{'is-invalid': submitted && StationControls.state.errors}">
                            <div *ngFor="let validation of validation_messages.state">
                                <div class="error-message" *ngIf="StationControls.state.hasError(validation.type) && ((StationControls.state.dirty  || StationControls.state.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>        

                </div>

                <div class="row">                     

                   

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="nt">Country *</label>
                            <input id="nt" class="form-control" [readonly]="isEditMode" formControlName="country" placeholder="Country" type="text" [ngClass]="{'is-invalid': submitted && StationControls.country.errors}">
                            <div *ngFor="let validation of validation_messages.country">
                                <div class="error-message" *ngIf="StationControls.country.hasError(validation.type) && ((StationControls.country.dirty  || StationControls.country.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="zipcode">Zipcode *</label>
                            <input id="zipcode" class="form-control" [readonly]="isEditMode" formControlName="zipcode" placeholder="Zipcode" type="text" maxlength="10" [ngClass]="{'is-invalid': submitted && StationControls.zipcode.errors}">
                            <div *ngFor="let validation of validation_messages.zipcode">
                                <div class="error-message" *ngIf="StationControls.zipcode.hasError(validation.type) && ((StationControls.zipcode.dirty  || StationControls.zipcode.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="station">Outsourced *</label>
                            <ng-select id="station" [multiple]="false" required formControlName="outSourcedStation" [ngClass]="{'is-invalid': submitted && StationControls.outSourcedStation.errors}" placeholder="Outsourced" >
                                <ng-option *ngFor="let OC of ousourcedConformation" [value]="OC.id">
                                   {{OC.name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.outSourcedStation">
                                <div class="error-message" *ngIf="StationControls.outSourcedStation.hasError(validation.type) &&  ((StationControls.outSourcedStation.dirty || StationControls.outSourcedStation.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>  

                </div>

                <!-- <div class="row">

                    <div class="col-lg-4 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="empid">Status * </label>
                            <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && StationControls.active.errors}" placeholder="Select Status" >
                                <ng-option *ngFor="let status of statusTypes" [value]="status.id">
                                    {{status.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>  

                </div> -->
                
                <div class="row">
                    <div class="col-md-12 py-3">
                        <button id="saveCustomerBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddStation(stationForm.value)" *ngIf="!isEditMode">Add Station</button>
                        <button id="updateCustomerBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateStation(stationForm.value)" *ngIf="isEditMode">Update Station </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>